var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("prompt", {
    attrs: {
      title: _vm.title,
      body: _vm.body,
      icon: "fa fa-trash",
      buttons: [
        {
          name: _vm.resource("Button_No"),
          class: "btn btn-secondary btn-sm",
          emit: "no",
          icon: "fa fa-times"
        },
        {
          name: _vm.resource("Button_Yes"),
          class: "btn btn-primary btn-sm",
          emit: "yes",
          icon: "fas fa-check"
        }
      ]
    },
    on: { yes: _vm.confirm, hidden: _vm.onHidden },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c("div", { staticClass: "row form-group" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("p", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.body) +
                      "\n                "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.displayCommentPrompt
              ? _c("div", { staticClass: "row form-group" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("label", { attrs: { for: "removalComment" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.resource(
                            "JourneyComposer_BrickSettingsBase_Comment_Label"
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("comment-editor", {
                        attrs: { id: "removalComment" },
                        model: {
                          value: _vm.comment,
                          callback: function($$v) {
                            _vm.comment = $$v
                          },
                          expression: "comment"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }